import { render, staticRenderFns } from "./IpoPortfolioDetails.vue?vue&type=template&id=2479836e"
import script from "./IpoPortfolioDetails.vue?vue&type=script&lang=js"
export * from "./IpoPortfolioDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports